import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type FiservPaymentModuleSpecsFragment } from '../../../../api/fragments/FiservPaymentModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { useFiservPaymentSettingsDrawer } from './FiservPaymentSettingsDrawer';

export type FiservPaymentSettingsEmptyListProps = {
    module: FiservPaymentModuleSpecsFragment;
};

const FiservPaymentSettingsEmptyList = ({ module }: FiservPaymentSettingsEmptyListProps) => {
    const { t } = useTranslation(['fiservPaymentModuleDetails']);
    const addFiservPaymentSettingsDrawer = useFiservPaymentSettingsDrawer(module.id);

    return (
        <>
            <NoItemResult
                extra={
                    <Button onClick={addFiservPaymentSettingsDrawer.open} type="primary">
                        {t('fiservPaymentModuleDetails:emptyList.paymentSettings.noData.action')}
                    </Button>
                }
                subTitle={t('fiservPaymentModuleDetails:emptyList.paymentSettings.noData.message')}
            />
            {addFiservPaymentSettingsDrawer.render()}
        </>
    );
};

export default FiservPaymentSettingsEmptyList;
